const AllBuyMoreBtns = document.querySelectorAll('.custom-product-info .buy-more-cover');
AllBuyMoreBtns.forEach(buyBtn=>{
  const Label_value = buyBtn.querySelector('.buy-more-content').getAttribute('data-label-for');
  const Buy_Save_Btn = buyBtn.querySelector('.buy-save');
  if(Buy_Save_Btn){
  Buy_Save_Btn.addEventListener('click',()=>{
    const getOptionQuantity = document.querySelectorAll('.product-button.custom-button');
    getOptionQuantity.forEach(option=>{
      if(option){        
        const option_Value = option.getAttribute('data-optionquantity');
        console.log(option_Value)
        if(Label_value == option_Value){
          // console.log(option_Value);
          option.click();
        }
      }
    })
  })
}
});


  console.log("testing")
  
  const optionQuantityDivs = document.querySelectorAll('.product-button.custom-button');
  optionQuantityDivs.forEach(QuantityDiv=>{
    if(QuantityDiv){
      console.log(">>>>",QuantityDiv)
      const allQty_picker = document.querySelectorAll('.qty-picker');
      QuantityDiv.addEventListener('click',()=>{    
        const quantityAttribute = QuantityDiv.getAttribute('data-optionquantity');
        console.log("1>>>>",quantityAttribute)
        allQty_picker.forEach(picker=>{
          if(picker){          
            if(picker.getAttribute('data-title') == quantityAttribute){
              picker.click();
              setTimeout(()=>{
                document.querySelector('.main-button.js-add-to-cart').click();
                setTimeout(()=>{allQty_picker[0].click();}, 200);
              },100);
            }
          }
        })
      })
    }
  });


const _updateAtbBtn = (title, atbBtn = document.querySelector(".js-add-to-cart")) => {
  const selectedOption = atbBtn.closest('form').querySelector(
    `.js-variantOption[data-title="${title}"]`
  );
  atbBtn.closest('form')
    .querySelectorAll(`.js-variantOption[selected]`).forEach(function(select) {
      select.removeAttribute("selected");
    })
  const preorderInput = atbBtn.closest('form').querySelector('input#delivery-date');
  const skuInput =  atbBtn.closest('form').querySelector('input#sku');
  skuInput.value = `${selectedOption.dataset.sku}`
  skuInput.setAttribute('data-variant-id', `${selectedOption.dataset.id}`);
  preorderInput.disabled = true;
  preorderInput.value = '';
  preorderInput.setAttribute('data-variant-id', `${selectedOption.dataset.id}`);
  selectedOption.setAttribute("selected", "selected");
  const inventory = selectedOption.dataset.inventory;
  if (selectedOption.getAttribute("disabled")) {
    atbBtn.setAttribute("disabled", "disabled");
    atbBtn.classList.add("oos");
    atbBtn.innerHTML = "Out of Stock";
  } 
  else if(selectedOption.dataset.policy === 'continue' && selectedOption.dataset.inventory <=0){
    if(selectedOption.dataset.customButton){
      atbBtn.innerHTML = `${selectedOption.dataset.customButton}`
      preorderInput.disabled = false;
      preorderInput.value = `${selectedOption.dataset.estimatedDelivery}`;
    } else{
      atbBtn.innerHTML = "PRE-ORDER"
      preorderInput.value = `${selectedOption.dataset.estimatedDelivery}`;
      preorderInput.disabled = false;
    }
  }
  else if (atbBtn.dataset.preorder && inventory <= 0) {
    atbBtn.innerHTML = "Pre-Order";
  } 
  else {
    atbBtn.removeAttribute("disabled");
    atbBtn.classList.remove("oos");
    atbBtn.innerHTML = "Add To Cart"
  }
};



const _updatePrice = (price, card) => {
  if(card.querySelector('.money')){
    card.querySelector('.money').innerHTML = `£${price}`;
  } else {
    const currencyCode = Shopify.currency.active
    const localeTest = `${Shopify.locale}-${Shopify.country}`
    const getCurrencySymbol = (locale, currency) => (0).toLocaleString(locale, { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\d/g, '').trim()
    const currencySymbol = getCurrencySymbol(localeTest, currencyCode);
    card.querySelector('.currency-price').innerHTML = `${currencySymbol}${price} ${currencyCode}`

  }
  
}

function bottomVariantChange(e) {
  for (let bBtn of document.querySelectorAll(".bottom-option")) {
    bBtn.classList.remove("active");
  }
  const topSelected =
    document.querySelector(".active.top-option").dataset.title;
  e.dataset.variantOption = topSelected + " / " + e.dataset.title;
  e.classList.add("active");

  _updateAtbBtn(e.dataset.variantOption);
}

function topVariantChange(e) {
  const atbBtn = document.querySelector(".js-add-to-cart");
  for (let tBtn of document.querySelectorAll(".top-option")) {
    tBtn.classList.remove("active");
  }
  const bottomSelected = document.querySelector(".active.bottom-option").dataset.title;
  e.dataset.variantOption = e.dataset.title + " / " + bottomSelected;
  e.classList.add("active");

  _updateAtbBtn(e.dataset.variantOption);
}

function variantChangeQuickView(e, i) { 
    const atbBtn = e.closest("form").querySelector(".js-add-to-cart");
    for (let btn of e.closest(`[role="radiogroup"]`).querySelectorAll('button')) {
      btn.classList.remove("active");
      btn.setAttribute("aria-checked", "false");
    }

    e.classList.add("active");
    e.setAttribute("aria-checked", "true");

    let variantTitle = '';
    const otherSelecteds = e.closest("form").querySelectorAll(`[aria-checked="true"]`);
    for (let selected of otherSelecteds) {
      variantTitle += ` / ${selected.dataset.title}`
    } 

    variantTitle = variantTitle.slice(3)
    
    const options = e.closest("form").querySelectorAll(`.js-variantOption`);
    let selectedOption = options[0];
    for (let opt of options) {

      if (opt.dataset.title.toLowerCase() == variantTitle.toLowerCase()) {
        selectedOption = opt
      }
    }
    _updateAtbBtn(variantTitle, atbBtn);

    const price = Number(selectedOption.dataset.price) / 100;
    const card = e.closest('.collection-card');
    _updatePrice(price, card);

    const productOptions = e.closest("form").querySelectorAll(".flex.product-options");

    productOptions.forEach(function(option){
      if (option.getAttribute('data-attribute').includes("colour")){
        const inputParts = variantTitle.split(' / ');
        const color = inputParts[0].toLowerCase().trim();
        const cardImages = e.closest("form").querySelectorAll('.card-img.relative');

        cardImages.forEach(function(element) {
          element.classList.remove('active');
        });

        for (const element of cardImages) {
              if (element.getAttribute('data-title') === color) {
            element.classList.add('active');
            break;
          }
        }
      }
    });
    
}




const links = document.querySelectorAll('a[href*="#"]:not([href="#"])');

// var headerHeight = document.getElementById('shopify-section-header').offsetHeight;

links.forEach(function (elem) {
    elem.addEventListener('click', smoothScroll)
});

function smoothScroll(e) {
    e.preventDefault();

    const link = this.getAttribute("href");

    const offsetTop = document.querySelector(link).offsetTop + headerHeight;
    scroll({
        top: offsetTop,
        behavior: "smooth"
    });
}



  // if(document.querySelector('.video-box-slider')){
  //   new Flickity( document.querySelector('.video-box-slider'), {
  //     // options
  //     contain: true,
  //     cellAlign: 'center',
  //     wrapAround: true,
  //     pauseAutoPlayOnHover: false,
  //     prevNextButtons: true,
  //     pageDots: false,
  //     draggable: true,
  //     arrowShape: { x0: 30, x1: 65, y1: 30, x2: 65, y2: 35, x3: 65 }

  //   });

  // }

document.addEventListener('DOMContentLoaded', function() {
  document.body.classList.add('pageloaded');
});


  function productSwiper(){
    var mainCarousel = new Flickity('.main-carousel', {
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true
    });
    
    var thumbnailCarousel = new Flickity('.thumbnail-carousel', {
      asNavFor: '.main-carousel',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      centerMode: true
    });
  };

// document.addEventListener('DOMContentLoaded', function() {
//   productSwiper();
  
//   setTimeout(function() {
//       productSwiper();
//   }, 1000);

// });
document.addEventListener('DOMContentLoaded', () => {
setTimeout(function() {
  var swiper = new Swiper('.video-box-slider', {
    slidesPerView: 'auto',
    centeredSlides: true,
    paginationClickable: true,
    loop: false,
    slideToClickedSlide: true,
    navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    breakpoints: {
      // when window width is >= 320px
      749: {
        loop: false,
        slidesPerView: 'auto',
        centeredSlides: false,
          navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      }
    }
  });
}, 500);
});

// Custom Product JS
// const qtyButtons = document.querySelectorAll('.custom-product-info .qty-picker');
// qtyButtons.forEach(button => {
//   button.addEventListener('click', () => {
//     qtyButtons.forEach(otherButton => {
//       otherButton.classList.remove("active");
//       otherButton.setAttribute("aria-checked", false);
//     });
//     button.classList.add("active");
//     button.setAttribute('aria-checked', true);
//   });
// });


// const sizePicker = document.querySelectorAll('.custom-product-info .size-picker');
// sizePicker.forEach(button => {
//   button.addEventListener('click', () => {
//     sizePicker.forEach(otherButton => {
//       otherButton.classList.remove("active");
//       otherButton.setAttribute("aria-checked", false);
//     });
//     button.classList.add("active");
//     button.setAttribute('aria-checked', true);
//   });
// });



// const Buy_Save_Btn = document.querySelector('.custom-product-info .buy-save');
// if(Buy_Save_Btn){
//   Buy_Save_Btn.addEventListener('click',()=>{
//     const getOptionQuantity = document.querySelectorAll('.product-button.custom-button');
//     getOptionQuantity.forEach(option=>{
//       if(option){        
//         const option_Value = option.getAttribute('data-optionquantity');
//         console.log(option_Value)
//         if(option_Value == "3"){
//           option.click();
//         }
//         if(option_Value == "5"){
//           option.click();
//         }
//       }
//     })
//   })
// }

//document.addEventListener('DOMContentLoaded', () => {
// const AllBuyMoreBtns = document.querySelectorAll('.custom-product-info .buy-more-cover');
// AllBuyMoreBtns.forEach(buyBtn=>{
//   const Label_value = buyBtn.querySelector('.buy-more-content').getAttribute('data-label-for');
//   const Buy_Save_Btn = buyBtn.querySelector('.buy-save');
//   if(Buy_Save_Btn){
//   Buy_Save_Btn.addEventListener('click',()=>{
//     const getOptionQuantity = document.querySelectorAll('.product-button.custom-button');
//     getOptionQuantity.forEach(option=>{
//       if(option){        
//         const option_Value = option.getAttribute('data-optionquantity');
//         console.log(option_Value)
//         if(Label_value == option_Value){
//           // console.log(option_Value);
//           option.click();
//         }
//       }
//     })
//   })
// }
// })


//   console.log("testing")
  
//   const optionQuantityDivs = document.querySelectorAll('.product-button.custom-button');
//   optionQuantityDivs.forEach(QuantityDiv=>{
//     if(QuantityDiv){
//       console.log(">>>>",QuantityDiv)
//       const allQty_picker = document.querySelectorAll('.qty-picker');
//       QuantityDiv.addEventListener('click',()=>{    
//         const quantityAttribute = QuantityDiv.getAttribute('data-optionquantity');
//         console.log("1>>>>",quantityAttribute)
//         allQty_picker.forEach(picker=>{
//           if(picker){          
//             if(picker.getAttribute('data-title') == quantityAttribute){
//               picker.click();
//               setTimeout(()=>{
//                 document.querySelector('.main-button.js-add-to-cart').click();
//                 setTimeout(()=>{allQty_picker[0].click();}, 200);
//               },100);
//             }
//           }
//         })
//       })
//     }
//   })
//});

// const AddtoCart_Btn = document.querySelector('.js-add-to-cart');
// if(AddtoCart_Btn){
//   AddtoCart_Btn.addEventListener('click',()=>{
//     console.log("clicked");
//     console.log(document.querySelector('.qty-picker').getAttribute('data-title'))
//     const option_Value = document.querySelector('.qty-picker').getAttribute('data-title');
//     if(option_Value == "1"){
//       document.querySelector('.qty-picker').click();
//     }  
//   })
// }



function setHeaderHeight() {
    const header = document.getElementById('shopify-section-header');
    if (header) {
        const headerHeight = header.offsetHeight;
        document.documentElement.style.setProperty('--header_height', `${headerHeight}px`);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

  
  const All_Sizes_Cards = document.querySelectorAll('.complementary-product.complementary-js-card');
  All_Sizes_Cards.forEach(Card=>{
    const Sizes = Card.querySelectorAll('.flex.product-options.size button');
    Sizes.forEach(size=>{
      size.setAttribute('aria-checked', "false");
    });
  })
});



